/* src/app/location-users/location-user-grid/location-header/location-header.component.scss */
.location {
  width: 328px;
  height: 69px;
  padding: 11px;
  padding-top: 10px;
  padding-bottom: 9px;
  font-weight: normal;
  line-height: 16px;
  display: grid;
  grid-template-areas: "slic users" "name edit" "address address";
  row-gap: 1px;
}
.location div {
  height: 16px;
}
.location div:nth-child(1) {
  grid-area: slic;
  font-weight: 700;
}
.location div:nth-child(2) {
  grid-area: users;
  text-align: right;
}
.location div:nth-child(3) {
  grid-area: name;
  overflow: hidden;
  text-overflow: ellipsis;
}
.location div:nth-child(4) {
  grid-area: edit;
  text-align: right;
}
.location div:nth-child(5) {
  grid-area: address;
  overflow: hidden;
  text-overflow: ellipsis;
}
a {
  text-decoration: underline;
  color: #426DA9;
  font-size: 14px;
}
.filtered {
  text-decoration: none;
  font-weight: bold;
  color: inherit;
}
/*# sourceMappingURL=location-header.component.css.map */
